export const paymentFailed = 'Payment failed';
export const packersAndMovers = 'Packers & Movers';
export const bookingAmountToPay = 'Booking amount to pay';
export const note = 'Note:';
export const paymentFailureDesc =
  'Any amount deducted will be automatically refunded to the source account in 7-10 business days.';
export const close = 'Close';
export const paymentFailureImgUrl =
  'https://dom-content-vault-prod-cdn-assets.porter.in/payment_failure_57b845ed2a/payment_failure_57b845ed2a.svg';
